import SupplierTableHelper from './supplier-table-helper';
import SupplierUsersTableHelper from './supplier-users-table-helper';

const SupplierHelpers = {
    TableMain: SupplierTableHelper,
    TableUsers: SupplierUsersTableHelper
};

export default SupplierHelpers;